import * as Sentry from "@sentry/vue";
import {
  syncMonitoringScopeFromStorage,
  trackMonitoringEvent,
} from "~/utils/monitoring";

const clampSampleRate = (value: unknown, fallback: number): number => {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return fallback;
  }

  return Math.min(1, Math.max(0, parsed));
};

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const router = useRouter();
  const dsn = config.public.glitchtipDsn;

  if (!dsn) {
    return;
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    environment: config.public.glitchtipEnvironment,
    release: config.public.appRelease || undefined,
    sampleRate: clampSampleRate(config.public.glitchtipErrorSampleRate, 1),
    tracesSampleRate: clampSampleRate(
      config.public.glitchtipTraceSampleRate,
      import.meta.dev ? 1 : 0.1,
    ),
    autoSessionTracking: false,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
        routeLabel: "path",
      }),
    ],
    initialScope: (scope) => {
      scope.setTag("app_name", "evaluation-web");
      scope.setTag("app_type", "nuxt-spa");
      return scope;
    },
  });

  syncMonitoringScopeFromStorage();
  trackMonitoringEvent("monitoring_initialized", {
    route: router.currentRoute.value.fullPath,
  });

  router.afterEach((to, from) => {
    syncMonitoringScopeFromStorage();
    Sentry.addBreadcrumb({
      category: "navigation",
      type: "navigation",
      level: "info",
      message: to.fullPath,
      data: {
        from: from.fullPath,
      },
    });
  });

  nuxtApp.hook("page:finish", () => {
    syncMonitoringScopeFromStorage();
  });
});
